import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { PaymentMethodAttachInput, PaymentMethodAttachPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = PaymentMethodAttachInput;
type TData = PaymentMethodAttachPayload;

export const usePaymentMethodAttach = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation paymentMethodAttach($input: PaymentMethodAttachInput!) {
      paymentMethodAttach(input: $input) {
        success
        errors
        errorCode

        paymentMethod {
          brand
          last4
          expYear
          expMonth
        }
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
